var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { attrs: { tabindex: "0", id: "program-" + _vm.itemID } }, [
    _c("span", { staticClass: "list-item-info" }, [
      _c("span", { staticClass: "label" }, [_vm._v("Participating Supplier")]),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "value",
          attrs: {
            "aria-label": "Participating Supplier" + _vm.result.SupplierName
          }
        },
        [_vm._v(_vm._s(_vm.result.SupplierName))]
      )
    ]),
    _vm._v(" "),
    _c("span", { staticClass: "list-item-info" }, [
      _c("span", { staticClass: "label" }, [_vm._v("Accrual")]),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "value",
          attrs: {
            "aria-label":
              "Accrual" + _vm.calcPercent(_vm.result.AccrualPercent) + "%"
          }
        },
        [_vm._v(_vm._s(_vm.calcPercent(_vm.result.AccrualPercent)) + "%")]
      )
    ]),
    _vm._v(" "),
    _c("span", { staticClass: "list-item-info" }, [
      _c("span", { staticClass: "label" }, [_vm._v("Adv.")]),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "value",
          attrs: { "aria-label": "Adv" + _vm.result.SharedAdvertising }
        },
        [_vm._v(_vm._s(_vm.result.SharedAdvertising))]
      )
    ]),
    _vm._v(" "),
    !_vm.isReadOnly
      ? _c("span", { staticClass: "list-item-info item-control" }, [
          !_vm.iscurrentsub
            ? _c("span", {
                staticClass: "icon icon-plus add-supplier js-program-toggle",
                attrs: { "aria-label": "Add Supplier", tabindex: "0" },
                on: {
                  click: function($event) {
                    return _vm.addConfirm(_vm.iscurrentsub)
                  },
                  keydown: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.addConfirm(_vm.iscurrentsub)
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.iscurrentsub
            ? _c("span", {
                staticClass:
                  "icon icon-block remove-supplier js-program-toggle",
                attrs: { "aria-label": "Remove Supplier", tabindex: "0" },
                on: {
                  click: function($event) {
                    return _vm.removeConfirm(_vm.iscurrentsub)
                  },
                  keydown: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.removeConfirm(_vm.iscurrentsub)
                  }
                }
              })
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-accb32b8", { render: render, staticRenderFns: staticRenderFns })
  }
}